6<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId"></project-page-header>
      <div class="page-title">项目变更单</div>
      <div class="panel-body">
        <div class="panel-info-section relative-position w1200">
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="200">变更类型</th>
                <td width="32%">
                  <a-tag color="#3f51b5" v-if="record.changeType == 1">变更实施周期</a-tag>
                  <a-tag color="#3f51b5" v-else-if="record.changeType == 2">变更项目预算</a-tag>
                  <a-tag color="#3f51b5" v-else-if="record.changeType == 3">变更项目计划</a-tag>
                </td>
                <th width="160">提交日期</th>
                <td>{{ record.submitTime ? record.submitTime.substring(0, 10) : '' }}</td>
              </tr>
              <template v-if="record.changeType === 2">
                <tr>
                  <th>项目预算金额（变更前）</th>
                  <td colspan="3">{{ $utils.thousands(record.before.amount) }} 元</td>
                </tr>
                <tr>
                  <th>项目预算金额（变更后）</th>
                  <td colspan="3">{{ $utils.thousands(record.after.amount) }} 元</td>
                </tr>
                <tr>
                  <th valign="top">预算文件</th>
                  <td colspan="3">
                    <file-container :img-size="[120, 80]" :files="record.after.files" :belongId="projectId" fileSign="P01" v-if="record.after.files && projectId"></file-container>
                  </td>
                </tr>
              </template>
              <tr>
                <th valign="top">变更原因</th>
                <td colspan="3" v-html="$utils.convertToHtml(record.changeReason)"></td>
              </tr>
            </tbody>
          </table>
          <div class="check-img" v-if="[1, 2, 3, 4].includes(record.state)">
            <img src="~@/assets/images/audit.png" />
          </div>
        </div>
        <div class="text-center v-my-lg">
          <a-space>
            <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getChangeinfo } from '@/api/project/common'
export default {
  name: 'HouseProjectChangeinfo',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: undefined,
      changeId: undefined,
      loading: false,
      data: {},
      record: {},
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, cid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (cid) {
        // 草稿，预算从详情中取
        this.changeId = +cid
        this.loadDetail()
      }
    },
    loadProject() {
      viewHzPrj({ id: this.projectId }).then(({ data }) => {
        if (data.success) {
          this.data = data.result
        }
      })
    },
    loadDetail() {
      getChangeinfo(this.changeId).then(({ data }) => {
        if (data.success) {
          let record = data.result
          let { before, after } = JSON.parse(record.changeContent)
          record.before = before
          record.after = after
          this.record = record
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
